import { Component, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { BlockComponent } from '../block-organizer';

@Component({
  standalone: false,
  selector: 'startWrapper-block',
  templateUrl: './startWrapper-block.component.html',
  styleUrls: ['../tileblocks.component.scss', './startWrapper-block.component.scss']
})
export class StartWrapperBlockComponent implements BlockComponent, OnChanges {
  @Input() block: any;
  @Input() tileType: string;
  @Input() needsEnum: any[] = [];
  @Output() startWrapperView = new EventEmitter<any>();
  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['needsEnum'] || changes['tileType'] || changes['block']) {
      this.hydrateNeedNameFromEnum();
    }
  }

  /** Ensures `possible_needs` is at most one `{ id, name }` and name is filled from enum when missing. */
  private hydrateNeedNameFromEnum() {
    if (this.tileType !== 'safe_questionnaire' || !this.block?.data || !this.needsEnum?.length) {
      return;
    }
    const pn = this.block.data.possible_needs;
    if (!Array.isArray(pn) || pn.length === 0) {
      return;
    }
    const row = pn[0];
    const id = row?.id;
    if (id === undefined || id === null || id === '') {
      return;
    }
    const itm = this.needsEnum.find((i: any) => i.value === id);
    if (itm && this.isEmptyName(row.name)) {
      row.name = itm.displayName != null ? itm.displayName : '';
    }
  }

  private isEmptyName(name: any): boolean {
    return name === undefined || name === null || String(name).trim() === '';
  }

  get selectedNeedId(): string {
    const pn = this.block?.data?.possible_needs;
    if (!Array.isArray(pn) || !pn.length) {
      return '';
    }
    const id = pn[0].id;
    return id !== undefined && id !== null ? String(id) : '';
  }

  onNeedChange(event: MatSelectChange) {
    if (!this.block?.data) {
      return;
    }
    const v = event.value;
    if (v === '' || v === undefined || v === null) {
      this.block.data.possible_needs = [];
    } else {
      const itm = this.needsEnum.find((i: any) => i.value === v);
      const name = itm && itm.displayName != null ? itm.displayName : '';
      this.block.data.possible_needs = [{ id: v, name }];
    }
    this.onChange(event);
  }

  public onChange(e: any) {
    this.startWrapperView.emit({ 'action': 'startWrapperView', block: this.block });
  }
}
